import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { Shop } from './pages/Shop';
import { Product } from './pages/Product';
import { Cart } from './pages/Cart';
import { CartProvider } from './contexts/CartContext';
import { CartDrawer } from './components/shop/CartDrawer';
export function App() {
  useEffect(() => {
    document.title = 'BEAT - A Sober Soda, Done Right';
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="2mm2m8fvmev3y">
      <CartProvider data-id="element-1" data-mp="2mmltn2nna13q">
        <Routes data-id="element-2" data-mp="2mn5a0exnchfn">
          <Route path="/" element={<LandingPage data-id="element-4" data-mp="31aqeac69cmp5" />} data-id="element-3" data-mp="2mnnfm2678808" />
          <Route path="/shop" element={<Shop data-id="element-6" data-mp="31bi8bik7icdb" />} data-id="element-5" data-mp="31ayry6a7fw1e" />
          <Route path="/product/:handle" element={<Product data-id="element-8" data-mp="2wjgrdjc3fxgy" />} data-id="element-7" data-mp="31ctdnmtavs6j" />
          <Route path="/cart" element={<Cart data-id="element-10" data-mp="2wip6p3k1bk5g" />} data-id="element-9" data-mp="2wiyuqllirh8i" />
        </Routes>
        <CartDrawer data-id="element-11" data-mp="28u5ysp4wd9dw" />
      </CartProvider>
    </BrowserRouter>;
}